import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import NewsletterSignup from '../common/NewsletterSignup';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Remembering Leonard', path: '/remembering-leonard' },
    { name: 'LLAP Award', path: '/llap-tribute' },
    { name: 'The Anniversary', path: '/anniversary' },
    { name: 'The Film', path: '/film' },
    { name: 'Support Our Mission', path: '/donate' },
  ];

  return (
    <footer className="bg-[#0a0a0b] border-t border-gray-800/50">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Foundation Info */}
          <div className="md:col-span-1">
            <div className="text-4xl mb-4">🖖</div>
            <h3 className="text-xl font-bold text-white mb-4">Nimoy-Knight Foundation</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              The Nimoy-Knight Foundation was established by Leonard Nimoy's daughter Julie Nimoy and filmmaker David Knight to celebrate his remarkable life and share his message of hope, inspiration, and compassion with the world.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-semibold text-white mb-4">Valuable Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-amber-500 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-semibold text-white mb-4">Contact</h3>
            <a
              href="mailto:info@rememberingleonardnimoy.org"
              className="inline-flex items-center gap-2 text-gray-400 hover:text-amber-500 transition-colors text-sm"
            >
              <Mail className="w-4 h-4" />
              info@rememberingleonardnimoy.org
            </a>
          </div>

          {/* Newsletter Signup */}
          <div className="md:col-span-1">
            <NewsletterSignup variant="compact" />
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800/50 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Nimoy-Knight Foundation. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
